import globalState from '../state';
import CONSTANTS from '../constants';

let initialStateSol = globalState.solicitacao;

let alteracao = (state = initialStateSol.alteracao, action) => {
    var payload = action.payload;

    var acoes = {
        [CONSTANTS.CHANGE_ALTERACAO_GENERICO]: () => {
            var obj = {
                [action.payload.campoState]: action.payload.valor
            };
            return { ...state, ...obj };
        },
 
        [CONSTANTS.GET_DADOS_ALTERACAO.LOADING]: () => {
            return { ...state, carregando: true };
        },

        [CONSTANTS.GET_DADOS_ALTERACAO.SUCCESS]: () => {
            return { ...state, ...action.payload, carregando: false };
        },

        [CONSTANTS.GET_DADOS_ALTERACAO.ERROR]: () => {
            return { ...state, erro: action.payload.message || "ERROR", carregando: false };
        }
    };
    if (acoes[action.type]) {
        return acoes[action.type]();
    }
    return state;

};




export default alteracao;


// WEBPACK FOOTER //
// ./src/reducers/alteracao.js